import * as React from "react";
import DropTablesNav from "./DropTablesNav";
import AdLayout from "../../app-core/AdLayout";
import LootGrid from "../LootGrid";
import * as T from "common/src/bindings/Translation2";

type Tables = {
  grayEarly: Array<[number, Array<any>]>;
  grayLate: Array<[number, Array<any>]>;
  blueEarly: Array<[number, Array<any>]>;
  blueLate: Array<[number, Array<any>]>;
  goldEarly: Array<[number, Array<any>]>;
  goldLate: Array<[number, Array<any>]>;
  prismLate: Array<[number, Array<any>]>;
};

export default function LootOrbsTables({ tables }: { tables: Tables }) {
  return (
    <AdLayout>
      <div className="flex flex-col bg-bg rounded w-full md:w-[928px] pb-4">
        <DropTablesNav route={"LootOrbs"} />
        <h2 className="h2 p-4 flex items-center gap-1">
          {T.common("Loot Orbs") + " " + T.common("Rewards")}
        </h2>
        <h3 className="h2 p-4 mt-8 flex items-center gap-1">
          {T.common("Silver Orb") + " " + T.common("Stage 1-2 (2g)")}
        </h3>
        <LootGrid data={tables.grayEarly} />
        <h3 className="h2 p-4 mt-8 flex items-center gap-1">
          {T.common("Silver Orb") + " " + T.common("Stage 3+ (3g)")}
        </h3>
        <LootGrid data={tables.grayLate} />
        <h3 className="h2 p-4 mt-8 flex items-center gap-1">
          {T.common("Blue Orb") + " " + T.common("Stage 1-3 (6g)")}
        </h3>
        <LootGrid data={tables.blueEarly} />
        <h3 className="h2 p-4 mt-8 flex items-center gap-1">
          {T.common("Blue Orb") + " " + T.common("Stage 4+ (8g)")}
        </h3>
        <LootGrid data={tables.blueLate} />
        <h3 className="h2 p-4 mt-8 flex items-center gap-1">
          {T.common("Gold Orb") + " " + T.common("Stage 2-3 (15g)")}
        </h3>
        <LootGrid data={tables.goldEarly} />
        <h3 className="h2 p-4 mt-8 flex items-center gap-1">
          {T.common("Gold Orb") + " " + T.common("Stage 4+ (18g)")}
        </h3>
        <LootGrid data={tables.goldLate} />
        <h3 className="h2 p-4 mt-8 flex items-center gap-1">
          {T.common("Prismatic Orb") + " " + T.common("Stage 3+ (40g)")}
        </h3>
        <LootGrid data={tables.prismLate} />
      </div>
    </AdLayout>
  );
}
